import { useIntl } from 'react-intl'
import { useBookingDetailsStore } from '../../infrastructure/useBookingDetailsStore'
import { BookingDetailsSection } from './BookingDetailsSection'
import { BusDetailsCard } from './BusDetailsCard'
import styles from './BusDetailsSection.module.css'
import { IconRow } from './IconRow'

export function BusDetailsSection() {
  const { formatMessage } = useIntl()
  const busInformation = useBookingDetailsStore(state => state.busInformation)

  if (!busInformation) {
    return null
  }

  const { outbound, inbound } = busInformation

  return (
    <BookingDetailsSection
      iconName="BusRight"
      title={formatMessage({ id: 'booking_details_bus_details_title' })}
      description={formatMessage({ id: 'booking_details_bus_details_description' })}
    >
      <div className={styles.cards}>
        <BusDetailsCard stop={outbound} showPickupTime noBusTitle={formatMessage({ id: 'booking_details_bus_details_outbound_no_bus_title' })} noBusDescription={formatMessage({ id: 'booking_details_bus_details_outbound_no_bus_description' })} />
        <BusDetailsCard stop={inbound} noBusTitle={formatMessage({ id: 'booking_details_bus_details_inbound_no_bus_title' })} noBusDescription={formatMessage({ id: 'booking_details_bus_details_inbound_no_bus_description' })} />
      </div>
      <div className={styles.remark}>
        <IconRow glyph="InformationInCircle" description={formatMessage({ id: 'booking_details_bus_details_disclaimer' })} />
      </div>
    </BookingDetailsSection>
  )
}
